import React from 'react'

export function Iconfont(props){
	return <span {...props} className={`iconfont ${props.className}`}>{props.children}</span>
}